import { Badge } from 'src/design/atoms/Badge';
import React, { useMemo } from 'react';
import { DivisionDto } from 'src/api/FiretrolApiClient';
import { IDivision } from 'src/api/models/Division';
import { BadgeShortList } from 'src/design/molecules/BadgeShortList';

export interface IDivisionListProps {
  divisions?: IDivision[] | DivisionDto[];
  maxItems?: number;
}

/** @registry Sorted list of division names as capped badges, via BadgeShortList. */
export const DivisionList = React.memo<IDivisionListProps>(
  ({ divisions, maxItems = 1 }) => {
    const badges = useMemo(() => {
      const items =
        divisions?.sort((a, b) => a.name.localeCompare(b.name)) || [];

      return items.map((division: IDivision | DivisionDto) => (
        <Badge key={division.id}>{division.name}</Badge>
      ));
    }, [divisions]);

    return <BadgeShortList items={badges} maxItems={maxItems} />;
  },
);
